import { Feature } from "../../../applications/model/feature.model";
import { SubscriptionModel } from "@app/payment-management/components/suscriptions/model/subscription.model";
import { SubscriptionPackageServerModel } from "@app/core/services/product-services/models/package-subsriptions.server.model";

export class SubscriptionPackage {
  id?: number | undefined;
  productId?: number | undefined;
  name: string;
  description?: string | undefined;
  isPublished?: boolean | undefined;
  isFree?: boolean | undefined;
  features?: Feature[] | undefined;
  amount: number;
  interval: string;
  intervalCount: number;
  trialPeriodDays?: number | undefined;
  usageType: string;
  isSubscribed?: boolean | undefined;
  subscription?: SubscriptionModel | undefined;
  constructor(item?: SubscriptionPackageServerModel) {
    if (item) {
      this.id = item.id;
      this.productId = item.productId;
      this.name = item.name;
      this.description = item.description;
      this.isPublished = item.isPublished;
      this.isSubscribed = item.isSubscribed;
      this.isFree = item.isFree;
      this.amount = item.amount;
      this.interval = item.interval;
      this.intervalCount = item.intervalCount;
      this.trialPeriodDays = item.trialPeriodDays;
      this.usageType = item.usageType;
      this.features =
        item.features && item.features.length > 0
          ? item.features.map(res => {
              return new Feature(res);
            })
          : [];
      this.subscription = new SubscriptionModel(item.subscription);
    }
  }
}
